import { api } from "./axios";

// Artist related endpoints
// CRUD operations
export const artistsApi = {
  create: (data: any) => {
    return api.post("/artists/create-artist", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000,
    });
  },
  getAll: ({ page = 1, limit = 10, search = "" } = {}) =>
    api.get("/artists/get-all-artists", {
      params: {
        page,
        limit,
        search,
      },
    }),
    
  getOne: (id: string) => api.get(`/artists/get-artist/${id}`),

  update: (id: string, data: any) => {
    return api.put(`/artists/update-artist/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000,
    });
  },
  delete: (id: string) => api.delete(`/artists/delete-artist/${id}`),

 

  importCSV: (csvData: any[]) => {
    return api.post("/artists/import-csv", { csvData });
  },

  // Artist pitches
  getPitches: (artistId: string, { page = 1, limit = 10, search = "",  searchType = "artistName" } = {}) =>
    api.get(`/artists/get-artist-pitches/${artistId}`, {
      params: {
        page,
        limit,
        search,
        searchType,
      },
    }),

  // Duplicate detection endpoints
  checkSpotifyURI: (spotifyId: string) =>
    api.post(`/artists/check-spotify-uri`, { spotifyId }),

  checkDuplicates: (artistName: string, spotifyURI?: string) =>
    api.post("/artists/check-duplicates", { artistName, spotifyURI }),

  checkDuplicatesBatch: (data: {
    artistNames: string[];
    spotifyURIs: string[];
  }) => api.post("/artists/check-duplicates-batch", data),

  getArtistsMissingPhotos: () => api.get("/artists/get-missing-photos"),
};
